import CompetitionDisciplineDTO from "./CompetitionDisciplineDTO.js"
import DisciplineDTO from "./DisciplineDTO.js"
import PhaseDTO from "./PhaseDTO.js"
import SportEventDTO from "./SportEventDTO.js"

class CompetitionDTO {

    constructor(competitionData){
        if(!competitionData || Object.keys(competitionData).length === 0)
            return

        const {_id, provider, name, idNameConfig, competitionsDisciplines} = competitionData

        this._id = _id
        this.provider = provider
        this.name = name

        this.idNameConfig = idNameConfig

        this.competitionsDisciplines = competitionsDisciplines?.map(competitionDiscipline => new CompetitionDisciplineDTO(competitionDiscipline))
    }

}

export default CompetitionDTO